import api from "@/services/api";
// @ts-expect-error - api is not typed
const { get, post, put } = api.getPrefixedMethods("orderinfo");
const letterPath = (orderKey) => `submission/${orderKey}/medical-necessity-letter/`;
export const medicalNecessityLetterService = {
    startDraft: (orderKey) => post(letterPath(orderKey), {}),
    getDraft: (orderKey, taskId) => get(letterPath(orderKey), { params: { task_id: taskId } }),
    saveDraft: (orderKey, draftText) => put(letterPath(orderKey), { draftText }),
    attachDocument: (orderKey, draftText) => post(`${letterPath(orderKey)}document/`, { draftText }),
};
